export default "__VITE_ASSET__44KsvOY7__"